import Router from 'next/router';

import {
  getCarouselProductsSuccess,
  getExclusiveCellarProduct,
  getProduct,
  getProductsForCarousel,
  getProductSuccess,
  redirectBoxPage
} from '../slices/product.slice';
import { addApiErrorToast } from '../slices/toast.slice';
import { LocalStorageService } from '@/services/LocalStorage.service';
import { AppListenerEntry } from '@/redux';
import {
  hidePageProgress,
  hideRecommendationModal,
  showPageProgress
} from '@/redux/slices/gui.slice';
import { STORE_ID_DEFAULT } from '@/constants/stores';
import { KEYS } from '@/constants/keys';

export const epicGetProduct: AppListenerEntry = {
  actionCreator: getProduct,
  effect: async ({ payload }: ReturnType<typeof getProduct>, { dispatch, extra: { productsService } }) => {
    try {
      const product: any = await productsService.getProduct(payload.id);
      dispatch(getProductSuccess({ id: product._id, product }));
    } catch (error) {
      dispatch(addApiErrorToast({ error }));
    }
  }
};

export const epicGetExclusiveCellarProduct: AppListenerEntry = {
  actionCreator: getExclusiveCellarProduct,
  effect: async (_action: ReturnType<typeof getExclusiveCellarProduct>, { getState, dispatch }) => {
    const { auth, product } = getState();
    if (auth.loggedUser.isEc) {
      dispatch(getProduct({ id: product.id }));
    }
  }
};

export const epicRedirectBoxPage: AppListenerEntry = {
  actionCreator: redirectBoxPage,
  effect: async ({ payload }: ReturnType<typeof redirectBoxPage>, { getState, dispatch, extra: { productsService } }) => {
    const { storeId = STORE_ID_DEFAULT } = getState().root.storeConf;
    const { inStockId, item, qty, options, millesime } = payload;

    const groupId = (inStockId === 'L') ? 'caisse-panachee-livrable' : 'caisse-panachee-primeur';
    const groupIdByStore = `${groupId}-${storeId}`;

    try {
      const redirectUrl: any = await productsService.getWineboxUrl(groupIdByStore);
      LocalStorageService.setObject(KEYS.WINEBOX, { item, qty, options });
      // Redirect to winebox categ page
      Router.push(`/${redirectUrl.url}${millesime && inStockId !== 'L' ? '?filter=millesime:' + millesime : ''}`);
    } catch (error) {
      dispatch(addApiErrorToast({ error }));
    }
  }
};

export const epicGetCarouselProducts: AppListenerEntry = {
  actionCreator: getProductsForCarousel,
  effect: async ({ payload }: ReturnType<typeof getProductsForCarousel>, {
    getState,
    dispatch,
    extra: { productsService }
  }) => {
    try {
      dispatch(showPageProgress());
      const products = await productsService.getCarouselProducts({ ...payload });
      dispatch(getCarouselProductsSuccess(products));
    } catch (error) {
      dispatch(addApiErrorToast({ error }));
      if (getState().gui.recommendationModalVisible) {
        dispatch(hideRecommendationModal());
      }
    } finally {
      dispatch(hidePageProgress());
    }
  }
};
